import { render, staticRenderFns } from "./c-player__live.vue?vue&type=template&id=38a9afd8&scoped=true"
import script from "./c-player__live.vue?vue&type=script&lang=js"
export * from "./c-player__live.vue?vue&type=script&lang=js"
import style0 from "./c-player__live.vue?vue&type=style&index=0&id=38a9afd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9afd8",
  null
  
)

export default component.exports